export default __webpack_public_path__ + "static/media/how-it-works.24f7bda1.webp";